import { Injectable } from '@angular/core';
import { Toast, ToastOptions } from '../models/toast.model';
import { AppInsightsService } from './app-insights.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private logger: AppInsightsService, private sanitizer: DomSanitizer) {}
  toasts: Toast[] = [];

  public show(message: string, options: ToastOptions = { autohide: true }) {
    if (!this.isMessageInArray(message)) {
      message = this.stripHTML(message);
      this.toasts.push({ message, ...options });
    }
    //this.logger.logTrace('ToastMessage', { message: message });
  }

  public remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  public clear() {
    this.toasts.splice(0, this.toasts.length);
  }

  private isMessageInArray(message: string): boolean {
    const idx = this.toasts.findIndex((t) => t.message === message);

    return idx !== -1;
  }

  private stripHTML(message: string): string {
    if (message.startsWith('<')) {
      //ensure safe html || '' - SecurityContext.HTML is the only context that will not throw an exception when passed a plain string
      const sanitizedMessage: string = this.sanitizer.sanitize(SecurityContext.HTML, message) || '';
      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(sanitizedMessage, 'text/html');
      //extract and return plain text
      const textContent = parsedHtml.body.textContent || '';
      return textContent;
    }
    else {
      return message;
    }
  }
}
